<template>
  <div>
    <v-data-table
      style="background: #a9a9a93d"
      fixed-header
      :height="tableHeight"
      :items="data"
      :options.sync="options"
      :headers="headerList"
      :loading="tableLoading"
      :server-items-length="paginatorTotal"
      :footer-props="footerProps"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar
          flat
        >
          <v-divider
            class="mx-4"
            inset
            vertical
          />
          <v-spacer />
          <v-dialog
            v-model="officeDialog"
            max-width="540px"
          >
            <!--            TO DO uncomment for create btn-->
            <!--            <template v-slot:activator="{ on, attrs }">-->
            <!--              <v-btn-->
            <!--                color="primary"-->
            <!--                dark-->
            <!--                class="mb-2"-->
            <!--                v-bind="attrs"-->
            <!--                v-on="on"-->
            <!--              >-->
            <!--                Добавить-->
            <!--              </v-btn>-->
            <!--            </template>-->
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col
                      cols="12"
                      :sm="12"
                      :md="6"
                      class="py-0 my-0"
                    >
                      <v-text-field
                        v-model="legalEntityForm.inn"
                        label="ИНН"
                        :error-messages="formErrors('inn')"
                        required
                        @change="$v.legalEntityForm.inn.$touch()"
                        @blur="$v.legalEntityForm.inn.$touch()"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      :sm="12"
                      :md="6"
                      class="py-0 my-0"
                    >
                      <v-text-field
                        v-model="legalEntityForm.externalId"
                        label="Внешний ИД"
                        required
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      :sm="12"
                      class="py-0 my-0"
                    >
                      <v-autocomplete
                        v-model="legalEntityForm.legalEntityContractList"
                        :items="organizationContractList"
                        multiple
                        return-object
                        item-value="id"
                        item-text="title"
                        label="Контракты"
                        outlined
                        chips
                        small-chips
                        :search-input.sync="searchQuery"
                        append-outer-icon="fa-search"
                        @click:append-outer="onSearchBtnClicked"
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            close
                            @click="data.select"
                            @click:close="removeOffice(data.item)"
                          >
                            {{ data.item.title }}
                          </v-chip>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="blue darken-1"
                  text
                  @click="close"
                >
                  Отменить
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="save"
                >
                  сохранить
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog
            v-model="dialogDelete"
            max-width="500px"
          >
            <v-card>
              <v-card-title class="headline">
                Удалить этот юр. лицо?
              </v-card-title>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="blue darken-1"
                  text
                  @click="closeDelete"
                >
                  Нет
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="deleteItemConfirm"
                >
                  Да
                </v-btn>
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:item.contractList="{ item }">
        <span
          v-for="(contract) in item.contractList"
          :key="contract.id"
          style="border: thin teal; display: block; padding-top: 4px; padding-bottom: 4px;"
          class="px-3"
        >{{ `[${contract.title}, ${contract.externalId}]   ,` }} </span>
      </template>

      <template v-slot:item.options="{ item }">
        <!--        <div style="display: flex; flex-direction: row; justify-content: space-between">-->
        <!--          <v-icon-->
        <!--            small-->
        <!--            class="mr-2"-->
        <!--            @click="editItem(item)"-->
        <!--          >-->
        <!--            mdi-pencil-->
        <!--          </v-icon>-->
        <!--        </div>-->
      </template>
    </v-data-table>
  </div>
</template>
<script>
import ListMixin from '@/mixins/list-mixin.vue'
import storeUtils from '@/utils/store'
import storeLabel from '@/store/labels'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { formatDate } from '@/utils/date-util'
import { mapMutations } from 'vuex'

export default {
  name: 'LegaEntityTabComponent',
  components: { },
  mixins: [ListMixin, validationMixin],
  validations: {
    legalEntityForm: {
      inn: { required },
    }
  },
  props: {
    tableLoading: {
      type: Boolean
    },
    paginatorTotal: {
      type: Number
    },
    data: {
      type: Array
    },
    legalEntityList: {
      type: Array
    },
    legalEntityListOptions: {
      type: Object
    },
  },
  data: () => ({
    canView: false,
    searchQuery: '',
    options: {},
    viewLoading: false,
    headerList: [
      {
        text: 'Наименование',
        align: 'left',
        sortable: false,
        value: 'title',
      },
      {
        text: 'ИНН',
        align: 'left',
        sortable: false,
        value: 'inn',
      },
      {
        text: 'Внешний ИД',
        align: 'left',
        sortable: false,
        value: 'externalId',
      },
      {
        text: 'Контрасты',
        align: 'left',
        sortable: false,
        value: 'contractList',
      },
      { text: '', value: 'options' },
    ],

    officeDialog: false,
    dialogDelete: false,
    organizationContractList: [],
    legalEntityForm: {
      id: null,
      inn: '',
      title: '',
      externalId: null,
      officeList: [],
      legalEntityContractList: [],
    },
    defaultLegalEntity: {
      id: null,
      inn: '',
      title: '',
    },
  }),
  computed: {
    getPaginator () {
      // return this.$store.getters['client/getPaginator']
      return 100
    },
    getOfficeList () {
      return this.officeList.map((office) => ({ id: office.id, title: office.title }))
    },
    formTitle () {
      return `${!this.legalEntityForm.id ? 'Добавление' : 'редактирование'} Юр. лица`
    },
  },
  watch: {
    officeDialog (val) {
      if (val) {
        this.requestList()
      }

      val || this.close()
    },
    dialogDelete (val) {
      val || this.closeDelete()
    },
    options: {
      handler (val) {
        this.$emit('onOfficeOptionChange', val)
      },
      deep: true,
    },
  },
  created () {
    this.options = { ...this.legalEntityListOptions }
  },
  methods: {
    ...mapMutations({
      setDisplayNotifier: storeUtils.setterName(storeLabel.DISPLAY_NOTIFIER, storeLabel.COMMON_MODULE),
      setNotifierMessage: storeUtils.setterName(storeLabel.NOTIFIER_MESSAGE, storeLabel.COMMON_MODULE),
    }),
    formatDate (date, format = 'DD MMMM HH:mm') {
      return formatDate(date, format = 'DD MMMM HH:mm')
    },
    editItem (item) {
      this.legalEntityForm = {
        id: item.id,
        inn: item.inn,
        title: item.title,
      }
      this.officeDialog = true
    },

    deleteItem (item) {
      this.dialogDelete = true
    },

    async onSearchBtnClicked () {},

    async requestList () {
      this.organizationContractList = []
      this.hideLoader = this.currentTicket && this.currentTicket.id
      const response = await this.$store.dispatch(
        'organization/getOfficeContractList',
        { 'organization[id]': this.$route.params.id }
      )

      const data = response.data

      if (data && Array.isArray(data)) {
        this.organizationContractList = data
      }
      this.tableLoading = false
    },

    deleteItemConfirm () {
      this.closeDelete()
    },

    close () {
      this.officeDialog = false
      this.$nextTick(() => {
        this.legalEntityForm = Object.assign({}, this.defaultLegalEntity)
      })
    },

    closeDelete () {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.legalEntityForm = Object.assign({}, this.defaultLegalEntity)
        this.editedIndex = -1
      })
    },

    async save () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return false
      }
      const model = {
        ...{
          ...this.legalEntityForm,
          contractList: this.legalEntityForm.legalEntityContractList.map((item) => ({ id: item.id })),
          legalEntityContractList: undefined,
        },
        'organization': { 'id': this.$route.params.id },
      }

      this.showPageLoader()

      this.$store.dispatch(
        `organization/createLegalEntity`,
        model
      ).then((response) => {
        this.close()
        this.$emit('reloadLegalEntityList')
        this.hidePageLoader()
      }).catch(() => {
        this.hidePageLoader()
        this.setDisplayNotifier(true)
        this.setNotifierMessage(`Ошибка при поиске ИНН ЮР лица!! `)
      })
    },
    formErrors (field) {
      const errors = []
      const taskField = this.$v.legalEntityForm[field]
      if (!taskField.$dirty) return errors
      !taskField.required && errors.push('поле обязательно для заполнения.')
      return errors
    },
    removeOffice (office) {
      this.legalEntityForm.officeList = this.legalEntityForm.officeList.filter((item) => item.id !== office.id)
    },
  }
}
</script>

